import React from 'react';
import { Briefcase, ArrowRight, Code, Brain } from 'lucide-react';
import { Link } from 'react-router-dom';

const CareersPage = () => {
    const jobs = [
        {
            id: 1,
            title: 'AI Engineer',
            type: 'Full-time',
            location: 'Remote / Hybrid',
            description: 'We are looking for a passionate AI Engineer to design and implement cutting-edge artificial intelligence models. You will work on integrating Generative AI, natural language processing, and computer vision technologies into our enterprise solutions.',
            requirements: [
                'Strong proficiency in Python and deep learning frameworks (TensorFlow, PyTorch)',
                'Experience with Large Language Models (LLMs) and Prompt Engineering',
                'Familiarity with cloud platforms (AWS, Azure, or GCP)',
                '3+ years of experience in AI/ML development'
            ],
            icon: <Brain className="w-8 h-8 text-brand-gold" />
        },
        {
            id: 2,
            title: 'Software Engineer',
            type: 'Full-time',
            location: 'Remote',
            description: 'Join our core development team to build robust, scalable web applications. You will be responsible for full-stack development, working closely with designers and product managers to deliver high-quality software solutions.',
            requirements: [
                'Proficiency in React.js, Node.js, and modern JavaScript (ES6+)',
                'Experience with REST APIs and database management (MongoDB, PostgreSQL)',
                'Understanding of modern CI/CD pipelines and deployment',
                '2+ years of full-stack development experience'
            ],
            icon: <Code className="w-8 h-8 text-brand-gold" />
        }
    ];

    return (
        <div className="bg-brand-bg min-h-screen py-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* Header Section */}
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <h1 className="text-3xl md:text-4xl font-semibold text-brand-textLight mb-6 leading-tight">
                        Join Our <span className="text-brand-gold">Team</span>
                    </h1>
                    <p className="text-lg text-brand-textMuted">
                        Help us build the future of digital innovation. We're always looking for talented individuals who are passionate about AI, data science, and software engineering.
                    </p>
                </div>

                {/* Job Listings */}
                <div className="space-y-6 max-w-4xl mx-auto">
                    {jobs.map((job) => (
                        <div key={job.id} className="bg-brand-card rounded-2xl shadow-sm border border-gray-800 p-6 md:p-8 hover:border-brand-gold/30 hover:shadow-lg transition-all">
                            <div className="flex flex-col md:flex-row md:items-start justify-between gap-6">

                                <div className="flex items-start gap-4">
                                    <div className="p-3 bg-brand-gold/10 rounded-xl hidden sm:block">
                                        {job.icon}
                                    </div>
                                    <div>
                                        <h2 className="text-2xl font-bold text-brand-textLight mb-2">{job.title}</h2>
                                        <div className="flex flex-wrap gap-3 mb-4">
                                            <span className="px-3 py-1 bg-gray-800 text-brand-textMuted text-sm font-medium rounded-full flex items-center gap-1">
                                                <Briefcase className="w-4 h-4" />
                                                {job.type}
                                            </span>
                                            <span className="px-3 py-1 bg-gray-800 text-brand-textMuted text-sm font-medium rounded-full">
                                                {job.location}
                                            </span>
                                        </div>
                                        <p className="text-brand-textMuted mb-6 leading-relaxed">
                                            {job.description}
                                        </p>

                                        <div>
                                            <h3 className="font-semibold text-brand-textLight mb-3">Key Requirements:</h3>
                                            <ul className="list-disc list-inside space-y-2 text-brand-textMuted">
                                                {job.requirements.map((req, index) => (
                                                    <li key={index}>{req}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-4 md:mt-0 flex-shrink-0">
                                    <Link
                                        to="/contact-us"
                                        className="inline-flex items-center justify-center px-6 py-3 bg-brand-gold text-black font-semibold rounded-lg hover:bg-brand-goldHover transition-colors w-full md:w-auto"
                                    >
                                        Apply Now
                                        <ArrowRight className="ml-2 w-4 h-4" />
                                    </Link>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>

                {/* Not finding a match? */}
                <div className="mt-16 text-center">
                    <p className="text-brand-textMuted mb-4">Don't see a position that fits your skills?</p>
                    <Link to="/contact-us" className="text-brand-gold font-semibold hover:underline">
                        Send us your resume anyway &rarr;
                    </Link>
                </div>

            </div>
        </div>
    );
};

export default CareersPage;
